import * as con from '../../GlobalConstants.js'
import { GenericCell } from '../../templates/tables/Cells.js'
import { RefGridStrategyHook } from '../hooks/gridStrategyHooks.js'

const GridLevels = () => {
  const gridLevels = RefGridStrategyHook(con.GRID_LEVELS)
  const levels = [1, 2, 3, 4];
  

  return (
    <>        
      <div className="flex-fila nonFixedTable"> 
        <div className='flex-celda header-row'>ESCALÓN</div>
        <div className='flex-celda header-row'>INFERIOR</div>
        <div className='flex-celda header-row'>SUPERIOR</div>
        <div className='flex-celda header-row'>AMPLITUD</div>
      </div>
        
      {levels.map((nivel, index) => {
        const stepKey = `step_${index + 1}`;
        const lower = gridLevels?.[stepKey]?.[0]
        const upper = gridLevels?.[stepKey]?.[1]

        const range = (lower != null && upper != null)
          ? upper - lower 
          : 0;
        return (
          <div key={nivel} className="flex-fila nonFixedTable">
            <GenericCell
              cellType={con.TEXT}
              editing={false}
              value={nivel}
              evenRow={nivel % 2 === 0}
            />
            <GenericCell
              evenRow={nivel % 2 === 0}
              cellType={con.MONEY}
              editing={false}
              value={gridLevels[stepKey]?.[0]}
              currency={con.MONEY_COP}
            />
            <GenericCell
              evenRow={nivel % 2 === 0}
              cellType={con.MONEY}
              editing={false}
              value={gridLevels[stepKey]?.[1]}
              currency={con.MONEY_COP}
            />
            <GenericCell
              evenRow={nivel % 2 === 0}
              cellType={con.NUMERIC}
              editing={false}
              value={range}
            />
          </div>
        );
      })}
    </>
  )
}

export default GridLevels